import request from "../utils/request";

export function listWebApps() {
    return request({
        url: "/webapps/list",
        method: "get",
    });
}

export function getWebApp(id) {
    return request({
        url: `/webapps/${id}`,
        method: "get",
    });
}

export function getWebAppBySlug(slug) {
    return request({
        url: `/webapps/slug/${slug}`,
        method: "get",
    });
}

export function createWebApp(data) {
    return request({
        url: "/webapps",
        method: "post",
        data,
    });
}

export function updateWebApp(id, data) {
    return request({
        url: `/webapps/${id}`,
        method: "put",
        data,
    });
}

export function deleteWebApp(id) {
    return request.delete(`/webapps/${id}`);
}

export function checkSlugAvailability(slug, excludeId = null) {
    return request({
        url: "/webapps/check-slug",
        method: "get",
        params: { slug, excludeId },
    });
}

export function uploadWebAppProject(id, file, onUploadProgress) {
    const formData = new FormData();
    formData.append("zipFile", file);

    return request({
        url: `/webapps/${id}/upload`,
        method: "post",
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
    });
}

export const WEB_APPS_API = {
    listWebApps,
    getWebApp,
    getWebAppBySlug,
    createWebApp,
    updateWebApp,
    deleteWebApp,
    checkSlugAvailability,
    uploadWebAppProject,
};
